import type { RioCategory } from '@backoffice-frontend/graphql'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { getCategoryConfig } from '../config'

export const getRioCategoryRights = (category: RioCategory) => {
  return getCategoryConfig(category).rights
}

export const useHasRioWriteRights = (category: RioCategory): boolean => {
  return useUserHasAccess({
    allowedRights: getCategoryConfig(category).rights.write,
  })
}

export const useHasRioReadRights = (category: RioCategory): boolean => {
  return useUserHasAccess({
    allowedRights: getCategoryConfig(category).rights.read,
  })
}

export const useHasRioDeleteRights = (category: RioCategory): boolean => {
  return useUserHasAccess({
    allowedRights: getCategoryConfig(category).rights.delete,
  })
}

export const useHasRioAssigneeRights = (category: RioCategory): boolean => {
  const assigneeRights = getCategoryConfig(category).rights.assignee

  const hasAccess = useUserHasAccess({
    allowedRights: assigneeRights,
  })

  return assigneeRights.length === 0 ? false : hasAccess
}
